module.exports = __webpack_public_path__ + "static/media/solution-4-sec1.26d3966f.png";